/* istanbul ignore file */

import React from 'react';

import {
  COOKIE_MODAL_SCRIPT_PRELOAD_URL,
  DATA_DOMAIN_SCRIPT,
  DATA_DOMAIN_SCRIPT_TESTING,
} from '../../constants';

interface Props {
  useTestScript?: boolean;
}

export const CookieModal = ({ useTestScript = false }: Props) => {
  return (
    <>
      <script
        data-domain-script={useTestScript ? DATA_DOMAIN_SCRIPT_TESTING : DATA_DOMAIN_SCRIPT}
        src={COOKIE_MODAL_SCRIPT_PRELOAD_URL}
      />

      <script
        dangerouslySetInnerHTML={{
          __html: `function OptanonWrapper() {}`,
        }}
        type="text/javascript"
      />
    </>
  );
};
